import { FeatureSessionStoreModuleType } from "UidispatcherApiModule";
const { FeatureSessionStoreModule }: { FeatureSessionStoreModule: FeatureSessionStoreModuleType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export const FeatureSessionStore = FeatureSessionStoreModule.default;
